import React from 'react';

// LIBS
import classNames from 'classnames';

// COMPONENTS
import { Image } from 'semantic-ui-react';

const BoxedLogo = props => {
  const { className, logo } = props;
  const logoBoxClasses = classNames(
    'logo-box',
    className,
  );

  return (
    <div className={logoBoxClasses}>
      <div className="logo-box-inner">
        <Image src={logo} />
      </div>
    </div>
  );
}

export default BoxedLogo;